import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import useAuth from "./useAuth";
import useRetryFetch from "./useRetryFetch";
import { listPwfs } from "../api/pwf";
import { buildProjectIndex, type ProjectRef } from "../lib/projectIndex";

/** Titles/areas for the project chip on takeaways — shares the
 *  ["cockpit-projects"] cache the cockpit already keeps warm. */
export function useProjectIndex(): { projectById: Record<string, ProjectRef>; isLoading: boolean } {
  const { auth } = useAuth();
  const retryFetch = useRetryFetch();
  const enabled = Boolean(auth?.email && auth?.accessToken);
  const { data, isLoading } = useQuery({
    queryKey: ["cockpit-projects"],
    queryFn: () => listPwfs(retryFetch),
    staleTime: 30_000,
    enabled,
  });
  const projectById = useMemo(() => buildProjectIndex(data ?? []), [data]);
  return { projectById, isLoading: enabled && isLoading };
}
